import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { WidgetService } from '../../shared/service/widget.service';
import { DomUtilService } from '../../shared/service/dom-util.service';
import { Router } from '@angular/router';
import { MainMapService } from '../../shared/service/main-map.service';
import { UserService } from '../../core/service/user.service';
import { ArbeitsbereichService } from '../../shared/service/arbeitsbereich.service';
import { WidgetNotifyService } from '../../shared/service/widget-notify.service';
import { CONSTANTS, CONSTANTS_VALUE } from '../../config/constants.module';
import { ToggleSidebarService } from '../../shared/service/toggle-sidebar.service';
import { takeUntil } from 'rxjs/operators';
import { TakeUntilDestroy } from '../../core/component/take-until-destroy';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent extends TakeUntilDestroy implements OnInit, OnDestroy {
  public creationToolPermitted = false;

  constructor(
    public router: Router,
    private _widgetService: WidgetService,
    private _domUtilService: DomUtilService,
    private _mainMapService: MainMapService,
    private _userService: UserService,
    private _arbeitsbereichService: ArbeitsbereichService,
    private _widgetNotifyService: WidgetNotifyService,
    private toggleSidebarService: ToggleSidebarService,
    private cdr: ChangeDetectorRef,
    @Inject(CONSTANTS) private _CONST: any
  ) {
    super();
  }

  ngOnInit() {
    // get current arbeitsbereich
    this._arbeitsbereichService.onChangeArbeitsbereichSubject
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.setCreationToolPermitted();
      });

    // get role for draw
    this._userService.onUserUpdateSubject.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.setCreationToolPermitted();
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  /**
   * @function toggleSidebar
   * @description Toggles the sidebar
   */
  private toggleSidebar(isToggled: boolean) {
    this.toggleSidebarService.set(isToggled);
  }

  /* Private methods
========================== */

  /**
   * @function setCreationToolPermitted
   * @description Set allowed actions by user roles.
   */
  private setCreationToolPermitted() {
    let creationPermitted = false;
    // Loop over each editable layer of current selected Arbeitsbereich
    if (!this._arbeitsbereichService.selectedArbeitsbereich.editableLayers) return;
    this._arbeitsbereichService.selectedArbeitsbereich.editableLayers.forEach(layer => {
      // check if logged user has right to edit on editable layer by editable layer ID
      if (this._userService.createFeaturePermitted(layer.fkLayer)) creationPermitted = true;
    });
    this.creationToolPermitted = creationPermitted;
    this.cdr.detectChanges();

    // remove creationTool if already open
    if (!creationPermitted) {
      this._widgetNotifyService.onComponentDestroySubject.next(this._CONST.WIDGET_ID.DrawComponent);
    }
  }

  /* WIDGET LIST
  ========================== */

  public showGeoPortaleWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.GeoPortaleComponent);
    this.toggleSidebar(false);
  }

  public showAppInfoWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.AppInfoComponent);
    this.toggleSidebar(false);
  }

  public requestFullscreen() {
    this._domUtilService.requestFullScreen();
    this.toggleSidebar(false);
  }

  public showCreationWidget() {
    this._mainMapService.closeWidgets();
    this._mainMapService.closeDetailViewWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.DrawComponent);
    this.toggleSidebar(false);
  }

  public showMassStabWidget() {
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.MassStabSliderComponent);
    this.toggleSidebar(false);
  }

  public showPrintWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.PrintComponent);
    this.toggleSidebar(false);
  }

  public showGoogleMapsWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.GoogleMapsComponent);
    this.toggleSidebar(false);
  }

  // Share
  public showShareWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.ShareComponent);
    this.toggleSidebar(false);
  }

  // Measure
  public showMeasureWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.MeasureComponent);
    this.toggleSidebar(false);
  }
}
